import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

import {
  PostToWorkOrderOnSiteMessageThread,
  PostToWorkOrderOnSiteMessageThreadVariables,
} from '../../athena/types/PostToWorkOrderOnSiteMessageThread';

export const POST_TO_WORK_ORDER_ON_SITE_MESSAGE_THREAD = gql`
  mutation PostToWorkOrderOnSiteMessageThread(
    $authorId: String!
    $content: String!
    $newStatus: OdProtosRefurbyData_MessageThreadStatus!
    $workOrderId: String!
  ) {
    refurby {
      postToWorkOrderOnSiteMessageThread(
        input: {
          authorId: $authorId
          content: $content
          newStatus: $newStatus
          workOrderId: $workOrderId
        }
      ) {
        onSiteMessageThread {
          notes {
            id
          }
        }
      }
    }
  }
`;

export const usePostToWorkOrderOnSiteMessageThread = () => {
  return useMutation<
    PostToWorkOrderOnSiteMessageThread,
    PostToWorkOrderOnSiteMessageThreadVariables
  >(POST_TO_WORK_ORDER_ON_SITE_MESSAGE_THREAD);
};
